import type { StatusItemId } from './api';

export const STEP_IDS = [
  'welcome',
  'look',
  'services',
  'staff',
  'rules',
  'deposit',
  'terms',
  'line',
  'share',
] as const;

export type StepId = (typeof STEP_IDS)[number];

/** `?step=deposit` opens that step of the booking page (the menu search links straight to it). */
export function validateBookingSearch(s: Record<string, unknown>): { step?: StepId } {
  return { step: STEP_IDS.find((id) => id === s.step) };
}

/** Which wizard step fixes each checklist item. */
export const STEP_OF_ITEM: Record<StatusItemId, StepId> = {
  services_online: 'services',
  staff_online: 'staff',
  hours_set: 'rules',
  deposit_account: 'deposit',
  line_oa_connected: 'line',
  rich_menu_installed: 'line',
};
